// extracted by mini-css-extract-plugin
module.exports = {"layout":"j5","content":"j6","a":"j7","footer":"j8"};